import client, {QueryOptions} from "@irati/utils/services/apollo"
import codes from "../errorCodes/Login"
import isAuthedQuery from "./queries/isAuthed"

class WhoAmI {
  isAuthed(options: Omit<QueryOptions, "fetchPolicy"> = {}): Promise<Boolean> {
    return client
      .query({...options, fetchPolicy: "no-cache", query: isAuthedQuery})
      .catch(() => {
        const e = <PBError>new Error()
        e.code = codes.InvalidLoginDetails
        throw e
      })
      .then(() => true)
  }
}

const whoAmI = new WhoAmI()

export const isAuthed = whoAmI.isAuthed

export default whoAmI
